import React, { useEffect, useState } from "react";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Tab, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import Breadcrumb from "../../components/breadcrumb";
import StepProgress from "../../components/StepProgress";

function UserDetails_n() {
  const [toggle, setToggle] = useState({ key: "", status: false });
  const [isShowMobile, setShowMobile] = useState(false);
  const navigate = useNavigate();

  const handleToggle = (key) => {
    if (toggle.key === key) setToggle({ status: false });
    else setToggle({ status: true, key });
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({ live: false });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bookingType, setBookingType] = useState("self");

  const [formData, setFormData] = useState({
    Named: "",
    Gender: "",
    Dateofbirth: "",
    Cno: "",
  });
  const [errors, setErrors] = useState({});
  const { reservationId } = useParams();
  const API_BASE = "https://adhigyanam-e92bf1bbbdb1.herokuapp.com";

  // Fetch navigation categories
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [res1, res2, res3, res4] = await Promise.all([
          axios.get(`${API_BASE}/blogcategoriessort`),
          axios.get(`${API_BASE}/horoscopecategoriessort`),
          axios.get(`${API_BASE}/astrocategoriessort`),
          axios.get(`${API_BASE}/coursecategoriessort`),
        ]);
        setCategories(res1.data);
        setCategoriesnew(res2.data);
        setCategoriesnew1(res3.data);
        setCategoriesnew2(res4.data);
      } catch {}
    };
    fetchAll();
  }, []);

  // Fetch reservation
 useEffect(() => {
  const fetchReservation = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/slot_reservations/${reservationId}`
      );

      if (res.data) {
        setReservation(res.data);
      }
    } catch (err) {
      console.error("Error fetching reservation:", err);
    } finally {
      setLoading(false);
    }
  };

  if (reservationId) fetchReservation();
}, [reservationId]);

  // Fetch user details
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;
        const res = await axios.get(`${API_BASE}/customersfetch/${userId}`);
        if (res.data && res.data.length > 0) {
          const c = res.data[0];
          setFormData({
            Named: c.Named || "",
            Gender: c.Gender || "",
            Dateofbirth: c.Dateofbirth || "",
            Cno: c.Cno || "",
          });
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    if (bookingType === "self") fetchUser();
    else setFormData({ Named: "", Gender: "", Dateofbirth: "", Cno: "" });
  }, [bookingType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.Named.trim()) newErrors.Named = "Name is required";
    if (!formData.Gender.trim()) newErrors.Gender = "Gender is required";
    if (!formData.Dateofbirth.trim()) newErrors.Dateofbirth = "Date of Birth is required";
    if (!formData.Cno.trim()) newErrors.Cno = "Contact number is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      const payload = {
        reservation_id: reservation?.id,
        booking_id: reservation?.booking_id,
        category: reservation?.booking_category,
        ...formData,
      };
      const res = await axios.post(`${API_BASE}/save-userdetails-n`, payload);
      if (res.data.success) navigate(`/payment/${reservation?.id}`);
      else alert("Failed to save details. Please try again.");
    } catch (err) {
      console.error("Error saving details:", err);
      alert("Something went wrong while saving details.");
    }
  };

 const toLocalDate = (isoString) => {
  if (!isoString) return null;
  const safe = isoString.replace("Z", "");
  const [datePart, timePart] = safe.split("T");
  const [y, m, d] = datePart.split("-").map(Number);
  const [hh, mm, ss] = timePart.split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, ss || 0);
};

  const formatDateTime = (isoString) => {
  const d = toLocalDate(isoString);
  if (!d) return "";

  return d.toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });
};

  return (
    <>
      <Helmet>
        <title>Finalise Your Booking - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>

      <div className="menu-mobile-popup">
                    <div className="modal-menu__backdrop" onClick={handleMobile}></div>
                    <div className="widget-filter">
                      <div className="mobile-header">
                        <div id="logo" className="logo">
                          <Link to="/home">
                            <img className="site-logo" src={logo} alt="Image" />
                          </Link>
                        </div>
                        <Link className="title-button-group" onClick={handleMobile}>
                          <i className="icon-close"></i>
                        </Link>
                      </div>
      
                      <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
                      <div className="header-customize-item button" style={{padding: "0px 0px",
                background:"none",
                backgroundColor:"#14a077",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "21px",
                color: "white",
                borderColor: "transparent",
                textTransform: "capitalize"}}>
                        <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
                      </div>
                      <div className="header-customize-item button">
                        <Link to="/login">My Account</Link>
                      </div>
      
                       <div className="mobile-footer">
                        <div className="icon-infor d-flex aln-center">
                          <div className="icon">
                            <span className="icon-call-calling">
                              <span className="path1"></span>
                              <span className="path2"></span>
                              <span className="path3"></span>
                              <span className="path4"></span>
                            </span>
                          </div>
                          <div className="content">
                            <p>Need help? 24/7</p>
                            <h6>
                               <Link to={`tel:918960708425`}>+91-8960708425</Link>
                            </h6>
                          </div>
                        </div>
                        <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                        <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                        <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
                  <ul className="list-social d-flex aln-center">
                                                 <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                                 <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                                 <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                             </ul>
                </div>
                      </div>
                    </div>
                  </div>

      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumb title="Finalise Your Booking" />

      <section
        className="booking-review-section"
        style={{
          padding: "60px 0",
          paddingTop: "30px",
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
        }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12 text-center mb-4">
              <h2
                style={{
                  fontSize: "26px",
                  fontWeight: "700",
                  color: "#1e1e1e",
                  marginBottom: "10px",
                }}
              >
                Complete Your Booking
              </h2>
              <p
                style={{
                  maxWidth: "650px",
                  margin: "0 auto 20px",
                  color: "#555",
                  fontSize: "15px",
                }}
              >
                Review your details and provide the required information to finalise your booking.
              </p>
              <StepProgress activeStep={3} />
            </div>

            <div className="col-md-10" style={{ margin: "auto" }}>
              <div className="row g-4" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                {/* ---- A. Review Booking ---- */}
               <div className="col-md-6">
            {loading ? (
              <p style={{ color: "#14A078", textAlign: "center" }}>
                Loading booking details...
              </p>
            ) : reservation ? (
              <div
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "12px",
                  padding: "30px 25px",
                 background: "#f9fafb",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <h6
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "black",
                    marginBottom: "15px",
                  }}
                >
                  A. Review Booking Details
                </h6>
                 <hr/>
               <div
  style={{
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: "15px",
    color: "#333",
    lineHeight: "1.6",
    width: "100%",
    
    overflow: "hidden",
   
  }}
>
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
    }}
  >
    <tbody>
      <tr style={{ backgroundColor: "#f8f9fa" }}>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            width: "40%",
            borderBottom: "1px solid #eee",
            paddingLeft:"0px",
          }}
        >
          Astrologer
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
          }}
        >
          {reservation.astrologer_name}
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            borderBottom: "1px solid #eee",
               paddingLeft:"0px",
          }}
        >
          Category
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
          }}
        >
          {reservation.booking_category}
        </td>
      </tr>

        <tr>
                              <td
                                style={{
                                  padding: "6px 18px",
                                  fontWeight: "600",
                                  borderBottom: "1px solid #eee",
                                  paddingLeft: "0px",
                                }}
                              >
                                Selected Plan
                              </td>
                              <td style={{ padding: "6px 18px", borderBottom: "1px solid #eee" }}>
                                {reservation.customer_name}
                              </td>
                            </tr>

      <tr>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            borderBottom: "1px solid #eee",
               paddingLeft:"0px",
          }}
        >
          Topic(s) Selected
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
          }}
        >
          {reservation.topics || "N/A"}
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            borderBottom: "1px solid #eee",
               paddingLeft:"0px",
          }}
        >
          Schedule Date
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
          }}
        >
          {new Date(reservation.start_datetime).toLocaleDateString("en-IN", {
            dateStyle: "full",
          })}
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            borderBottom: "1px solid #eee",
               paddingLeft:"0px",
          }}
        >
          Start Time
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
             
          }}
        >
          {formatDateTime(reservation.start_datetime)}
        </td>
      </tr>

      <tr>
        <td
          style={{
            padding: "6px 18px",
            fontWeight: "600",
            borderBottom: "1px solid #eee",
           paddingBottom:"20px",
              paddingLeft:"0px",
          }}
        >
          End Time
        </td>
        <td
          style={{
            padding: "6px 18px",
            borderBottom: "1px solid #eee",
              paddingBottom:"20px",
          }}
        >
          {formatDateTime(reservation.end_datetime)}
        </td>
      </tr>
    </tbody>
  </table>

  {/* Highlighted Fee Block */}
  <div
    style={{
      backgroundColor: "#f2f2f2",
      textAlign: "center",
      padding: "10px",
      fontSize: "18px",
      fontWeight: "600",
      color: "#14A078",
      lineHeight:"23px"
      
    }}
  >
    eConsultation Fee: ₹{reservation.booking_price}.00
    <br />
                              <span style={{ color: "black", fontSize: "13px", fontWeight: 500 }}>(Inclusive Of All Taxes)</span>
  </div>
</div>
              </div>
            ) : (
              <p style={{ textAlign: "center", color: "crimson" }}>
                Reservation not found.
              </p>
            )}
          </div>

                {/* ---- B. Booking For Self / Others ---- */}
                <div className="col-md-6">
                  <div
                    style={{
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "30px 25px",
                      background: "#f9fafb",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
                    }}
                  >
                    <h6 style={{ fontSize: "16px", fontWeight: "700", color: "black", marginBottom: "15px" }}>
                      B. Booking For Self / Others
                    </h6>
                    <hr />

                    <div
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        gap: "20px",
                        fontSize: "15px",
                        color: "#333",
                      }}
                    >
                      <label style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          value="self"
                          checked={bookingType === "self"}
                          onChange={() => setBookingType("self")}
                          style={{
                            marginRight: "8px",
                            accentColor: "#14A078",
                          }}
                        />
                        Book for Self
                      </label>
                      <label style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          value="others"
                          checked={bookingType === "others"}
                          onChange={() => setBookingType("others")}
                          style={{
                            marginRight: "8px",
                            accentColor: "#14A078",
                          }}
                        />
                        Book for Someone Else
                      </label>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="row g-3">
                        {[
                          { name: "Named", label: "Full Name*", type: "text" },
                          { name: "Gender", label: "Gender*", type: "select" },
                          { name: "Dateofbirth", label: "Date of Birth*", type: "date" },
                          { name: "Cno", label: "Contact Number*", type: "tel" },
                        ].map((field, idx) => (
                          <div className="col-md-6" key={idx}>
                            <label
                              style={{
                                display: "block",
                                fontWeight: "600",
                                fontSize: "14px",
                                marginBottom: "5px",
                                color: "#222",
                              }}
                            >
                              {field.label}
                            </label>
                            {field.type === "select" ? (
                              <select
                                name={field.name}
                                value={formData[field.name]}
                                onChange={handleChange}
                                className="form-control"
                                style={{
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                  fontSize: "14px",
                                }}
                              >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                            ) : (
                              <input
                                type={field.type}
                                name={field.name}
                                value={formData[field.name]}
                                onChange={handleChange}
                                className="form-control"
                                style={{
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                  fontSize: "14px",
                                  backgroundColor: "white",
                                  color: "black",
                                }}
                                maxLength={field.name === "Cno" ? 10 : undefined}
                              />
                            )}
                            {errors[field.name] && (
                              <small style={{ color: "crimson", fontSize: "12px" }}>
                                {errors[field.name]}
                              </small>
                            )}
                          </div>
                        ))}
                      </div>

                      <div style={{ textAlign: "center", marginTop: "25px" }}>
                        <button
                          type="submit"
                          style={{
                            background: "#14A078",
                          color: "#fff",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 40px",
                          fontSize: "15px",
                          fontWeight: "800",
                          letterSpacing: "0.3px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          textTransform:"none",
                          }}
                          onMouseOver={(e) => (e.target.style.background = "#118a65")}
                          onMouseOut={(e) => (e.target.style.background = "#14A078")}
                        >
                          Final Step: Complete Your Booking
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Contact Buttons */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          zIndex: "1000",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <a
          href="tel:+918960708425"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#007BFF",
            borderRadius: "50%",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaPhoneAlt />
        </a>

        <a
          href="https://wa.me/918960708425"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaWhatsapp />
        </a>
      </div>

      <Footer />
      <Gotop />
    </>
  );
}

export default UserDetails_n;